import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const stsettingApi = createApi({
  reducerPath: 'stsettingApi',
  baseQuery: btBaseQuery,
  tagTypes: ['STSetting'],

  endpoints: (builder) => ({
    getSTSettings: builder.query<st_asetting[], void>({
      query: () => `stsetting/`,
      providesTags: ['STSetting']
    }),
    getSTSettingById: builder.query<st_asetting, string>({
      query: (id) => `stsetting/byid/${id}`,
      providesTags: ['STSetting']
    }),
    insertSTSetting: builder.mutation({
      query: (stsetting) => ({
        url: `/stsetting/`,
        method: 'POST',
        body: stsetting
      }),
      invalidatesTags: ['STSetting']
    }),
    updateSTSetting: builder.mutation({
      query: (stsetting) => ({
        url: `/stsetting/`,
        method: 'PUT',
        body: stsetting
      }),
      invalidatesTags: ['STSetting']
    }),
    deleteSTSetting: builder.mutation({
      query: (stsetting) => ({
        url: `/stsetting/${stsetting.cm_id}`,
        method: 'DELETE',
        body: stsetting
      }),
      invalidatesTags: ['STSetting']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSTSettingsQuery,
  useGetSTSettingByIdQuery,
  useInsertSTSettingMutation,
  useUpdateSTSettingMutation,
  useDeleteSTSettingMutation
} = stsettingApi;
